import React, { Component } from "react";
import BTlogoHeader from "../../assets/TTGLogoWithoutText.png";
import "./header.css";

class YourComponent extends Component {
  constructor(props) {
    super(props);
    this.searchInputRef = React.createRef();
  }

  focusSearchInput = () => {
    if (this.searchInputRef.current) {
      this.searchInputRef.current.focus();
    }
  };

  render() {
    const { isSearchBarVisible, handleInputChange, handleKeyDown } = this.props;

    return (
      <>
        {isSearchBarVisible && (
          <div
            className="search-bar"
            onClick={(event) => event.stopPropagation()}
          >
            <input
              type="text"
              className="search-input"
              placeholder="Search"
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              ref={this.searchInputRef}
            />
          </div>
        )}
      </>
    );
  }
}

class Header extends Component {
  constructor(props) {
    super(props);
    this.dropdownRef = React.createRef();
    this.flagDropdownRef = React.createRef();
    this.searchRef = React.createRef();
    this.yourComponentRef = React.createRef();
    this.loginDropdownRef = React.createRef();
  }

  state = {
    isDropdownVisible: false,
    isSearchBarVisible: false,
    isFlagDropdownVisible: false,
    isLoginDropdownVisible: false, // Update this to false
    searchInput: "",
  };

  handleMenuIconClick = () => {
    this.setState((prevState) => ({
      isDropdownVisible: !prevState.isDropdownVisible,
      isFlagDropdownVisible: false,
      isSearchBarVisible: false,
      isLoginDropdownVisible: false,
    }));
  };

  handleSearchIconClick = (event) => {
    event.stopPropagation();

    this.setState(
      (prevState) => ({
        isSearchBarVisible: !prevState.isSearchBarVisible,
        isDropdownVisible: false,
        isFlagDropdownVisible: false,
      }),
      () => {
        if (this.state.isSearchBarVisible && this.yourComponentRef.current) {
          this.yourComponentRef.current.focusSearchInput();
        }
      }
    );
  };

  handleInputChange = (event) => {
    const inputValue = event.target.value.toLowerCase();
    this.setState({ searchInput: inputValue });
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (this.state.searchInput === "få offert") {
        window.location.href = "få-offert";
      } else  if (event.target.value === "brand" || event.target.value === "märke" || event.target.value === "om" || event.target.value === "om oss" || event.target.value === "vem är vi" || event.target.value === "vem är snaithe")  {
        window.location.href = "https://snaithe.com/about";
      } else  if (event.target.value === "history" || event.target.value === "historik" || event.target.value === "gammal" || event.target.value === "old") {
        window.location.href = "https://snaithe.com/history";
      } else if (this.state.searchInput === "snaithe") {
        window.location.href = "https://snaithe.com";
      } else if (this.state.searchInput === "home") {
        window.location.href = "/";
      } else if (this.state.searchInput === "tjänster") {
        window.location.href = "tjänster";
      } else if (this.state.searchInput === "kontakta") {
        window.location.href = "kontakta-oss";
 } else {
        window.location.href = "404-page";
      }
    }
  };

  handleLoginIconClick = (event) => {
    event.stopPropagation();
    this.setState((prevState) => ({
      isLoginDropdownVisible: !prevState.isLoginDropdownVisible,
      isDropdownVisible: false,
      isFlagDropdownVisible: false,
      isSearchBarVisible: false,
    }));
  };

  handleFlagDropdownClick = () => {
    this.setState((prevState) => ({
      isFlagDropdownVisible: !prevState.isFlagDropdownVisible,
      isDropdownVisible: false,
      isSearchBarVisible: false,
      isLoginDropdownVisible: false,
    }));
  };

  handleDocumentClick = (event) => {
    const { dropdownRef, flagDropdownRef, searchRef, loginDropdownRef } = this;

    // Check if the click is outside the dropdown menu
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      this.state.isDropdownVisible
    ) {
      this.setState({
        isDropdownVisible: false,
        isFlagDropdownVisible: false,
        isLoginDropdownVisible: false,
        isSearchBarVisible: false,
      });
    } else if (
      flagDropdownRef.current &&
      !flagDropdownRef.current.contains(event.target) &&
      this.state.isFlagDropdownVisible
    ) {
      // Check if the click is outside the flag dropdown
      this.setState({
        isFlagDropdownVisible: false,
        isLoginDropdownVisible: false,
        isSearchBarVisible: false,
      });
    } else if (
      loginDropdownRef.current &&
      !loginDropdownRef.current.contains(event.target) &&
      this.state.isLoginDropdownVisible
    ) {
      // Check if the click is outside the login dropdown
      this.setState({
        isFlagDropdownVisible: false,
        isLoginDropdownVisible: false,
        isSearchBarVisible: false,
      });
    } else {
      // Check if the click is outside the search bar
      if (
        searchRef.current &&
        !searchRef.current.contains(event.target) &&
        this.state.isSearchBarVisible
      ) {
        this.setState({
          isSearchBarVisible: false,
        });
      }

      // Close other dropdowns
      this.setState({
        isLoginDropdownVisible: false,
      });
    }
  };

  componentDidMount() {
    document.addEventListener("click", this.handleDocumentClick);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  render() {
    const {
      isDropdownVisible,
      isSearchBarVisible,
      isFlagDropdownVisible,
      isLoginDropdownVisible,
    } = this.state;
    return (
      <div>
        <header className="header">
          <a href="/" className="logo-bidtype">
            <img src={BTlogoHeader} alt="Logo" className="logo-bidtype1" />
          </a>
          {isDropdownVisible && (
            <div className="three-name-header">
              <a href="/" className="Home-1">
                <div className="Buy-2">Hem</div>
              </a>

              <a href="/tjänster" className="Brands-1">
                <div className="Bid-2">Tjänster</div>
              </a>

              <a href="/få-offert" className="Services-1">
                <div className="Sell-2">Få offert</div>
              </a>
              <a
                href="https://snaithe.com/about/"
                target="_blank"
                rel="noopener noreferrer"
                className="Brands-1"
              >
                <div className="Bid-2">Våra Märke</div>
              </a>

              <a href="/kontakta-oss" className="Packages-1">
                <div className="Sell-2">Kontakta</div>
              </a>
            </div>
          )}
          <div className="icons">
            <div
              className="icon-search-header"
              onClick={this.handleSearchIconClick}
              ref={this.searchRef}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M6.28849 3.80274e-08C7.48381 -0.000131381 8.65442 0.34037 9.66318 0.981616C10.6719 1.62286 11.4771 2.53829 11.9843 3.62068C12.4914 4.70306 12.6797 5.90756 12.5269 7.09308C12.3742 8.27859 11.8867 9.39603 11.1217 10.3145L15.4595 14.6522C15.5347 14.7221 15.5897 14.811 15.6187 14.9095C15.6477 15.0081 15.6496 15.1126 15.6241 15.2121C15.5987 15.3116 15.5469 15.4024 15.4742 15.4749C15.4014 15.5474 15.3105 15.599 15.2109 15.6242C15.1116 15.6497 15.0071 15.6479 14.9087 15.6191C14.8102 15.5902 14.7213 15.5354 14.6514 15.4603L10.3137 11.1226C9.53746 11.7689 8.61704 12.2187 7.63023 12.434C6.64342 12.6494 5.61927 12.6239 4.6444 12.3597C3.66952 12.0956 2.77261 11.6005 2.02953 10.9164C1.28645 10.2323 0.71906 9.37929 0.375353 8.42954C0.0316463 7.47979 -0.078265 6.46123 0.0549165 5.46002C0.188098 4.45881 0.560455 3.5044 1.14049 2.67752C1.72052 1.85065 2.49117 1.17564 3.38725 0.70958C4.28332 0.243523 5.27846 0.000133388 6.28849 3.80274e-08ZM1.14268 6.28932C1.14268 6.96508 1.27578 7.63422 1.53438 8.25854C1.79299 8.88286 2.17202 9.45012 2.64986 9.92796C3.12769 10.4058 3.69496 10.7848 4.31928 11.0434C4.94359 11.302 5.61274 11.4351 6.28849 11.4351C6.96425 11.4351 7.63339 11.302 8.25771 11.0434C8.88203 10.7848 9.4493 10.4058 9.92713 9.92796C10.405 9.45012 10.784 8.88286 11.0426 8.25854C11.3012 7.63422 11.4343 6.96508 11.4343 6.28932C11.4343 4.92457 10.8922 3.61571 9.92713 2.65069C8.9621 1.68566 7.65325 1.14351 6.28849 1.14351C4.92374 1.14351 3.61488 1.68566 2.64986 2.65069C1.68483 3.61571 1.14268 4.92457 1.14268 6.28932Z"
                  fill="#fff"
                />
              </svg>
            </div>
            <div
              className="icon-menu-header"
              onClick={this.handleMenuIconClick}
              ref={this.dropdownRef}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3 16.7984C3 16.5988 3.07932 16.4073 3.2205 16.2661C3.36169 16.1249 3.55318 16.0456 3.75284 16.0456H18.8097C19.0093 16.0456 19.2008 16.1249 19.342 16.2661C19.4832 16.4073 19.5625 16.5988 19.5625 16.7984C19.5625 16.9981 19.4832 17.1896 19.342 17.3308C19.2008 17.4719 19.0093 17.5513 18.8097 17.5513H3.75284C3.55318 17.5513 3.36169 17.4719 3.2205 17.3308C3.07932 17.1896 3 16.9981 3 16.7984ZM3 10.7757C3 10.576 3.07932 10.3845 3.2205 10.2434C3.36169 10.1022 3.55318 10.0228 3.75284 10.0228H18.8097C19.0093 10.0228 19.2008 10.1022 19.342 10.2434C19.4832 10.3845 19.5625 10.576 19.5625 10.7757C19.5625 10.9754 19.4832 11.1668 19.342 11.308C19.2008 11.4492 19.0093 11.5285 18.8097 11.5285H3.75284C3.55318 11.5285 3.36169 11.4492 3.2205 11.308C3.07932 11.1668 3 10.9754 3 10.7757ZM3 4.75296C3 4.5533 3.07932 4.36181 3.2205 4.22062C3.36169 4.07944 3.55318 4.00012 3.75284 4.00012H18.8097C19.0093 4.00012 19.2008 4.07944 19.342 4.22062C19.4832 4.36181 19.5625 4.5533 19.5625 4.75296C19.5625 4.95263 19.4832 5.14412 19.342 5.2853C19.2008 5.42649 19.0093 5.5058 18.8097 5.5058H3.75284C3.55318 5.5058 3.36169 5.42649 3.2205 5.2853C3.07932 5.14412 3 4.95263 3 4.75296Z"
                  fill="#fff"
                />
              </svg>
            </div>

            <div
              className="flag-icon"
              onClick={this.handleFlagDropdownClick}
              ref={this.flagDropdownRef}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="18"
                viewBox="0 0 27 18"
                fill="none"
              >
                <path d="M0 0.5H27V17.5H0V0.5Z" fill="#012169" />
                <path
                  d="M3.16406 0.5L13.4578 6.91042L23.7094 0.5H27V2.69583L16.875 9.03542L27 15.3396V17.5H23.625L13.5 11.1604L3.41719 17.5H0V15.375L10.0828 9.07083L0 2.76667V0.5H3.16406Z"
                  fill="white"
                />
                <path
                  d="M17.8875 10.4521L27 16.0833V17.5L15.5672 10.4521H17.8875ZM10.125 11.1604L10.3781 12.4L2.27813 17.5H0L10.125 11.1604ZM27 0.5V0.60625L16.4953 7.26458L16.5797 5.70625L24.8906 0.5H27ZM0 0.5L10.0828 6.73333H7.55156L0 1.9875V0.5Z"
                  fill="#C8102E"
                />
                <path
                  d="M10.1672 0.5V17.5H16.9172V0.5H10.1672ZM0 6.16667V11.8333H27V6.16667H0Z"
                  fill="white"
                />
                <path
                  d="M0 7.33542V10.7354H27V7.33542H0ZM11.5172 0.5V17.5H15.5672V0.5H11.5172Z"
                  fill="#C8102E"
                />
              </svg>
              <div
                className={
                  isFlagDropdownVisible
                    ? "flag-dropdown visible"
                    : "flag-dropdown"
                }
                ref={this.flagDropdownRef}
              >
                <ul class="flag-dropdown visible">
                  <a href="/en-us">
                    <li class="flag-option">
                      <svg
                        class="flag-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="27"
                        height="20"
                        viewBox="0 0 27 20"
                        fill="none"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="27"
                          height="18"
                          viewBox="0 0 27 18"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_245_879)">
                            <path
                              d="M0 0.655273H27V17.6553H0V0.655273Z"
                              fill="#012169"
                            />
                            <path
                              d="M3.16406 0.655273L13.4578 7.06569L23.7094 0.655273H27V2.85111L16.875 9.19069L27 15.4949V17.6553H23.625L13.5 11.3157L3.41719 17.6553H0V15.5303L10.0828 9.22611L0 2.92194V0.655273H3.16406Z"
                              fill="white"
                            />
                            <path
                              d="M17.8875 10.6074L27 16.2386V17.6553L15.5672 10.6074H17.8875ZM10.125 11.3157L10.3781 12.5553L2.27813 17.6553H0L10.125 11.3157ZM27 0.655273V0.761523L16.4953 7.41986L16.5797 5.86152L24.8906 0.655273H27ZM0 0.655273L10.0828 6.88861H7.55156L0 2.14277V0.655273Z"
                              fill="#C8102E"
                            />
                            <path
                              d="M10.1672 0.655273V17.6553H16.9172V0.655273H10.1672ZM0 6.32194V11.9886H27V6.32194H0Z"
                              fill="white"
                            />
                            <path
                              d="M0 7.49069V10.8907H27V7.49069H0ZM11.5172 0.655273V17.6553H15.5672V0.655273H11.5172Z"
                              fill="#C8102E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_245_879">
                              <rect
                                width="27"
                                height="17"
                                fill="white"
                                transform="translate(0 0.655273)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </svg>
                      <span class="flag-label">English</span>
                    </li>
                  </a>
                  <a href="/">
                    <li class="flag-option">
                      <svg
                        class="flag-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="27"
                        height="20"
                        viewBox="0 0 27 20"
                        fill="none"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="27"
                          height="20"
                          viewBox="0 0 27 20"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_245_161)">
                            <path d="M0 0H27V20H0V0Z" fill="#066AA7" />
                            <path d="M0 8H27V12H0V8Z" fill="#FECC00" />
                            <path
                              d="M7.42505 0H11.475V20H7.42505V0Z"
                              fill="#FECC00"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_245_161">
                              <rect width="27" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>{" "}
                      </svg>
                      <span class="flag-label">Swedish</span>
                    </li>
                  </a>
                </ul>
              </div>
            </div>

            <YourComponent
              ref={this.yourComponentRef}
              isSearchBarVisible={isSearchBarVisible}
              handleInputChange={this.handleInputChange}
              handleKeyDown={this.handleKeyDown}
            />
          </div>
        </header>
      </div>
    );
  }
}

export default Header;
